import MixinStringManipulation from '../MixinStringManipulation'
import axios from "axios";
import {useInformationStore} from "@/stores/InformationStore";
import {isEqual, uniqWith} from "lodash";
import {mapWritableState} from "pinia";

let informationFileName = 'get_information.php'
let isLocalhost;

if (window.location.hostname.indexOf('localhost') !== -1 && window.location.port === '8080') {
    // For running commands via ssh, local otherwise for production
    isLocalhost = true;
} else {
    isLocalhost = false;
}

export default {
    mixins: [MixinStringManipulation],
    computed: {
        ...mapWritableState(useInformationStore, {
            informationProgressBar: 'informationProgressBar',
        })
    },
    methods: {

        /** All methods here should have a prefix of config for code organisation purpose. */
        async configLoadInformation(currentConnection) {

            let self = this;

            self.informationProgressBar = true;

            if (currentConnection?.value?.type?.toLowerCase() === 'ftp') {
                informationFileName = 'get_information_via_ftp.php';
            } else {
                informationFileName = 'get_information.php';
            }

            return await axios.get(informationFileName, {
                params: {
                    currentConnection,
                    isLocalhost
                }
            }).then((response) => {

                self.informationProgressBar = false;

                if (response.data.status) {
                    return response.data.data
                }

            }).catch((error) => {
                // TODO: Log error
                console.log(error)
                self.informationProgressBar = false;
                return false
            })

        },

        configLoadInformationAndSetInStores() {

            let self = this;

            self.configLoadInformation(self.currentConnection).then(function (informationResponse) {

                const informationStore = useInformationStore();

                if (informationResponse?.unboundLogTxt && informationResponse.unboundLogTxt && informationResponse.unboundLogTxt.length > 0) {
                    informationStore.setUnboundLogTxt(informationResponse.unboundLogTxt);
                }

                if (informationResponse?.unboundLogJson && informationResponse.unboundLogJson && informationResponse.unboundLogJson.length > 0) {

                    let unboundLogArray = [];

                    informationResponse.unboundLogJson.map(function (value) {

                        // This helps skipping string text which is not useful for the table/grid. Such as: jan 05 05:39:26 unbound[3155:3] info: validation failure <_dns.resolver.arpa. type64 in>: no dnssec records from 8.8.8.8 for ds resolver.arpa. while building chain of trust
                        if (typeof value === 'object') {

                            unboundLogArray.push({
                                dateAndTime: value[0],
                                status: value[1],
                                domain: value[2],
                                ip: value[3],
                                user: value[4],
                                rule: value[5],
                            });

                        }
                    });

                    informationStore.setUnboundLogJson(unboundLogArray);

                }

                if (informationResponse?.connectedUsers && informationResponse.connectedUsers && Object.keys(informationResponse.connectedUsers).length > 0) {

                    const connectedUsers = [];
                    let connectedUsersStatusOptions = ['All']

                    for (const ipKey in informationResponse.connectedUsers) {

                        if (informationResponse.connectedUsers[ipKey].active) {
                            connectedUsersStatusOptions.push(informationResponse.connectedUsers[ipKey].active)
                        }

                        connectedUsers.push({
                            ipForSorting: ipKey,
                            active: informationResponse.connectedUsers[ipKey].active,
                            color: informationResponse.connectedUsers[ipKey].color,
                            hostname: informationResponse.connectedUsers[ipKey].hostname,
                            mac: informationResponse.connectedUsers[ipKey].mac,
                            ip: informationResponse.connectedUsers[ipKey].IP,
                            name: informationResponse.connectedUsers[ipKey].name,
                        });

                    }

                    connectedUsersStatusOptions = uniqWith(connectedUsersStatusOptions, isEqual)

                    informationStore.setConnectedUsers(connectedUsers)
                    informationStore.setConnectedUsersStatusFilterOptions(connectedUsersStatusOptions)



                }

                if (informationResponse.hasOwnProperty('idefixStatusDev')) {

                    let idefixStatusDev = informationResponse.idefixStatusDev;

                    if (typeof idefixStatusDev === 'string') {
                        idefixStatusDev = JSON.parse(idefixStatusDev);
                    }

                    informationStore.setIdefixStatusDev(idefixStatusDev);

                }

                if (informationResponse.hasOwnProperty('idefixStatus')) {

                    let idefixStatus = informationResponse.idefixStatus;

                    if (typeof idefixStatus === 'string') {
                        idefixStatus = JSON.parse(idefixStatus);
                    }

                    informationStore.setIdefixStatus(idefixStatus);

                }



            }).catch(function (error) {
                console.log(error);
            });

        }
    }
}
